import { render, staticRenderFns } from "./CmsAds.vue?vue&type=template&id=689167b7&scoped=true"
import script from "./CmsAds.vue?vue&type=script&lang=js"
export * from "./CmsAds.vue?vue&type=script&lang=js"
import style0 from "./CmsAds.vue?vue&type=style&index=0&id=689167b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689167b7",
  null
  
)

export default component.exports